import { RouteProps } from '@models'

import { authRoutes } from '../pages/auth/routes'
import { sysRoutes } from '../pages/sys/routes'
import { orgRoutes } from '../pages/org/routes'
import { taxRoutes } from '../pages/tax/routes'

/**
 * 组合应用所有路由信息
 */
let routes: RouteProps[] = []
routes.push.apply(routes, authRoutes)
routes.push.apply(routes, sysRoutes)
routes.push.apply(routes, orgRoutes)
routes.push.apply(routes, taxRoutes)

export {
    routes,
}